import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { useScroll } from '../../hooks/index.js';
import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

import { PanelContext } from './PanelContext.js';

export type PanelElement = FlexElement;

export interface PanelProps extends FlexProps {}

export const Panel = styled(
  forwardRef<PanelElement, PanelProps>(({ children, ...restProps }, ref) => {
    const value = useScroll();
    return (
      <Flex ref={ref} column {...restProps}>
        <PanelContext.Provider value={value}>{children}</PanelContext.Provider>
      </Flex>
    );
  })
).withConfig({
  displayName: 'Panel',
})<PanelProps>`
  flex: 1;
  height: 100%;
`;
